const IP = '35.204.51.228';

module.exports = {
  App: {
    Type: 'App',
    Version: 14,
  },
  Conf: '/config.json?t=2',
  WS: {
    Host: IP,
    Port: 8080,
  },
  VueConfig: {
    runtimeCompiler: true,
  },
};